module.exports = __webpack_public_path__ + "media/images/favicons/android-chrome-512x512-161b4f8ff57af01d8e24186b202580a7.png";